// eslint-disable-next-line import/prefer-default-export
export enum METRIC_ENUM {
    cryptoMetric = 'CRYPTO_METRIC',
    baseMetric = 'BASE_METRIC',
}
